import { useDisclosure } from '@mantine/hooks';
import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

const LoginModalContext = createContext<{
  isOpened: boolean;
  open: () => void;
  close: () => void;
} | null>(null);

export const LoginModalProvider = ({ children }: { children: ReactNode }) => {
  const [isLoginModalOpened, handlers] = useDisclosure(false);

  return (
    <LoginModalContext.Provider
      value={{
        isOpened: isLoginModalOpened,
        open: handlers.open,
        close: handlers.close,
      }}
    >
      {children}
    </LoginModalContext.Provider>
  );
};

export const useLoginModalContext = () => {
  const context = useContext(LoginModalContext);

  if (!context) {
    throw new Error(`useLoginModalContext must be used within a LoginModalProvider`);
  }

  return context;
};
